import { reactive, computed, unref, watch } from 'vue'
import { useHttp } from '@core/composables/useHttp'

import API from '@core/api.js'
import { useRouter } from 'vue-router'

export const usePackage = (slug) => {
  const router = useRouter()
  const packageItem = reactive({})
  const slugRef = computed(() => unref(slug))

  const { isLoading, execute } = useHttp({ showErrorToast: false })

  const clearPackageItem = () => {
    Object.keys(packageItem).forEach((key) => {
      delete packageItem[key]
    })
  }

  const fetchPackage = () => {
    const packageSlug = slugRef.value

    if (!packageSlug) {
      clearPackageItem()
      return
    }

    clearPackageItem()

    execute(
      { url: API.packageResource.replace(':slug', packageSlug) },
      (item) => Object.assign(packageItem, item),
      (err) => {
        if (err) {
          // cors return status 0
          router.replace({ name: 'not-found' })
        }
      }
    )
  }

  watch(slugRef, fetchPackage, { immediate: true })

  return { packageItem, isLoading }
}
